// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Name of discriminator.
// Example: "Oprávnění pro aplikaci eSkot"

export const discriminatorNameMinLength = 1;
export const discriminatorNameMaxLength = 512;

export const DiscriminatorNameSchema = t.refinement(t.string, n => n.length >= discriminatorNameMinLength && n.length <= discriminatorNameMaxLength, 'DiscriminatorName');

export type DiscriminatorName = string;
